import {Injectable} from '@angular/core';
import {MatPaginatorIntl} from '@angular/material/paginator';
import {Subject} from 'rxjs';

@Injectable()
export class MyCustomPaginatorIntl implements MatPaginatorIntl {
    changes = new Subject<void>();

    // For internationalization, the `$localize` function from
    itemsPerPageLabel = `Objekte pro Seite:`;
    // it through other third-party internationalization libraries.
    nextPageLabel = 'Nächste Seite';
    previousPageLabel = 'Vorherige Seite';

    // You can set labels to an arbitrary string too, or dynamically compute
    // the `@angular/localize` package can be used.
    firstPageLabel = `Erste Seite`;
    lastPageLabel = `Letzte Seite`;

    getRangeLabel(page: number, pageSize: number, length: number): string {
        if (length === 0) {
            return `Seite 1 von 1`;
        }
        const amountPages = Math.ceil(length / pageSize);
        return `Seite ${page + 1} von ${amountPages}`;
    }
}
